/*
Using lodash as a module here, in future will use by importing from node_modules
*/
const lodash = window._

export default lodash